import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";
const styles = createUseStyles(theme => ({
  modalContent: {
    margin: "20px 0 0 0"
  },
  carouselTitle: {
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "28px",
    marginBottom: "8px",
    marginTop: "20px",
    color: colors.lightBlack,
    textAlign: "center"
  },
  carouselDescription: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: "8px",
    color: colors.mediumGrey,
    textAlign: "center"
  },
  carouselContainer: {
    paddingLeft: 0,
    paddingRight: 0,
    height: "auto",
    width: "100%",
    maxWidth: "1104px",
    "& .carousel-indicators": {
        marginBottom: "-20px",
        "& button": {
            opacity: 1,
            width: "8px",
            backgroundColor: colors.shadowGrey,
            borderRadius: "4px",
            height: "8px",
            border: "unset",
            marginLeft: "6px",
            marginRight: "6px"
        },
        "& .active": {
            backgroundColor: colors.primary700Blue
        }
    }
},
  travelCreditsWelcomeModal: {
    width: "400px",
    "& .modal-header": {
      padding: "0px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight:"600",
      lineHeight:"28px",
      overflowWrap: "break-word"
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight:"400",
      lineHeight:"20px",
    },
    "& .modal-body": {
      padding: "8px 24px",

    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  btnContainer:{
    marginTop:"40px",
    marginBottom:"16px",
  },
  carouselImage: {
    width: "100%",
    objectFit: "cover"
  },

  skipBtn: {
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
    height: "100%",
    alignItems: "center"
  },
  nextBtn: {
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
  },
  colSkip:{
    padding:"0px",
    marginRight:"6px"
  },
  colNext:{
    padding:"0px",
    marginLeft:"6px"
  },

}));

export default styles;